import {HttpErrorResponse} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {TranslateService} from '@ngx-translate/core';
import {MessageService} from 'primeng/api';
import {catchError, map, of, switchMap} from 'rxjs';
import {ErrorHandlerUtils} from 'src/app/core/utils/error-handler.utils';
import {ICategoryListResponseModel} from '../models/category-list-response.model';
import {CategoryListService} from '../services/category-list.service';
import {
  CategoryListActions,
  categoryListAction,
  categoryListEffectError,
  categoryListEffectFailure,
  categoryListEffectSuccess,
} from './category-list.actions';
@Injectable()
export class CategoryListEffects {
  private readonly actions$ = inject(Actions);
  private readonly categoryListService = inject(CategoryListService);
  private readonly messageService = inject(MessageService);
  private readonly translate = inject(TranslateService);

  globalToast = 'global-toast';

  categoryList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoryListActions.CategoryList),
      switchMap((action: ReturnType<typeof categoryListAction>) => this.categoryList(action))
    )
  );

  private categoryList(action: ReturnType<typeof categoryListAction>) {
    return this.categoryListService.getCategoryList(action.request).pipe(
      map((response: ICategoryListResponseModel[]) => {
        return categoryListEffectSuccess({response});
      }),
      catchError((error: HttpErrorResponse) => {
        const errMsg = ErrorHandlerUtils.getErrorMessage(this.translate, error.status);
        ErrorHandlerUtils.showErrorMessage(this.messageService, this.globalToast, errMsg);
        if (Array.isArray(error.error)) {
          return of(categoryListEffectFailure({reason: error.error.join(', ')}));
        } else if (typeof error.error === 'string') {
          return of(categoryListEffectFailure({reason: error.error}));
        } else {
          return of(categoryListEffectError(error));
        }
      })
    );
  }
}
